import { useEffect, useState } from 'react';

import CookieBanner from '@helsenorge/core-cms/cookie-banner';
import { updateAdobeAnalyticsConsent } from '@helsenorge/core-cms/cookie-banner/analytics';
import { hasConsentCookie } from '@helsenorge/core-cms/cookie-banner/cookie';
import { useSetShowCookieBanner } from '@helsenorge/core-cms/cookie-banner/events';
import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { deleteSharedCookie } from '@helsenorge/framework-utils/shared-cookies';

const YOUTUBE_TOS_COOKIE_NAME = 'hn-youtube-tos-accepted';

interface CookieBannerContainerProps {
  /**
   * Språk for tekster i cookiebanner
   */
  language: LanguageLocales;

  /**
   * Om cookiebanner skal skjules ved oppstart, selv om bruker ikke har gitt samtykke. Brukes for å
   * kunne skjule cookiebanner på sider som skal fortelle mer om cookies og samtykke.
   */
  hideInitially: boolean;
}

const CookieBannerContainer: React.FC<CookieBannerContainerProps> = (props: CookieBannerContainerProps) => {
  const [showCookieBanner, setShowCookieBanner] = useState<boolean>(!props.hideInitially && !hasConsentCookie());

  useEffect(() => {
    updateAdobeAnalyticsConsent();
    // @todo Kan fjernes en viss tid etter at cookiebanner er tatt i bruk
    deleteSharedCookie(YOUTUBE_TOS_COOKIE_NAME);
  }, []);

  useSetShowCookieBanner(detail => {
    setShowCookieBanner(detail.show);
  });

  if (!showCookieBanner) {
    return;
  }

  return <CookieBanner language={props.language} onSave={() => setShowCookieBanner(false)} />;
};

export default CookieBannerContainer;
